import { telegramName } from 'config/api.url.constant';
import { toast } from 'react-toastify'


export * from './format';

export function copyClipboard(value: string) {
    if (navigator.clipboard) {
        navigator.clipboard.writeText(value)
    } else {
        // text area method
        let textArea = document.createElement('textarea')
        textArea.value = value
        // make the textarea out of viewport
        textArea.style.position = 'fixed'
        textArea.style.left = '-999999px'
        textArea.style.top = '-999999px'
        document.body.appendChild(textArea)
        textArea.focus()
        textArea.select()
        document.execCommand('copy')
        textArea.remove()
    }
    toast('Copied to your Clipboard!', { type: 'success' })
}

export function generateInviteLink(userId: string) {
    return `https://t.me/${telegramName}?start=${userId}`
}